export enum InspectionStandard {
	PACP = 'PACP',
	MACP = 'MACP',
	WSA05 = 'WSA05',
}
